import PropTypes from 'prop-types';
import React from 'react';
import get from 'lodash/get';
import time from 'yoda-core-components/lib/moment/Time';
import PricingHelper from 'yoda-site-components/lib/components/Pricing/PricingHelper';

// inline styles are decalred for print option
function Print({ savedListItem }) {
    const priceDetailsView = () => {
        const pricingDetails =
            savedListItem.pricing &&
            savedListItem.pricing.amounts.length > 0 &&
            PricingHelper(savedListItem.pricing);

        const currentPrice = {
            fontFamily: 'OpenSans',
            fontSize: '14px',
            fontWeight: 'bold',
            color: '#1c2024',
            lineHeight: '1.71',
        };
        const priceType = {
            color: '#cb0c0b',
        };
        const oldSale = {
            fontFamily: 'OpenSans',
            fontSize: '10px',
            color: '#53606b',
            lineHeight: '1.6',
        };

        const couponMain = {
            fontFamily: 'OpenSans',
        };

        const couponBold = {
            fontWeight: 'bold',
        };

        const couponCss = {
            fontSize: '14px',
            color: '#cc0000',
        };

        const couponText = {
            fontSize: '10px',
        };

        const doorBuster = {
            fontFamily: 'OpenSans',
            fontSize: '8px',
            fontWeight: 'bold',
            color: '#cb0c0b',
        };

        if (!pricingDetails) {
            return null;
        }

        const originalPrice = savedListItem.pricing.amounts.filter(
            (amount) => amount.type.toUpperCase() === 'ORIGINAL'
        )[0];
        const originalPriceMin = get(originalPrice, 'min', 0);
        const originalPriceMax = get(originalPrice, 'max', 0);
        let from = '';

        if (originalPriceMin !== originalPriceMax) {
            from = 'from';
        }

        let couponAmount = get(savedListItem, 'pricing.couponInfo[0].amount.min', 0);
        if (couponAmount) {
            couponAmount = couponAmount.toLocaleString('en', { minimumFractionDigits: 2 });
        }
        const code = get(savedListItem, 'pricing.couponInfo[0].alphaId', '');

        return (
            <div>
                <p style={doorBuster} data-automation-id="at-price-promotions-label">
                    {pricingDetails.promotions}
                </p>
                {!couponAmount && pricingDetails.mapPrice && (
                    <p data-automation-id="at-price-map-price-label">{pricingDetails.mapPrice}</p>
                )}
                {!couponAmount && !pricingDetails.mapPrice && (
                    <p data-automation-id={`${pricingDetails.type}-price-info`}>
                        <span data-automation-id="at-price-value" style={currentPrice}>
                            {pricingDetails.defaults || pricingDetails.original}
                            <span data-automation-id="at-price-label" style={priceType}>
                                {' '}
                                {pricingDetails.type}
                            </span>
                        </span>
                    </p>
                )}

                {couponAmount !== 0 && (
                    <div style={couponMain}>
                        <div style={couponCss}>
                            {from} {`$${couponAmount}`}
                        </div>
                        <div style={couponText}> when you use code&nbsp;</div>
                        <div style={couponText}>
                            <span style={couponBold}>{code}</span> at checkout
                        </div>
                    </div>
                )}
                {couponAmount !== 0 && (
                    <p data-automation-id="price-old-sale" style={oldSale}>
                        was {pricingDetails.original || pricingDetails.defaults}
                    </p>
                )}
                {!couponAmount && (
                    <p data-automation-id="price-old-sale" style={oldSale}>
                        {pricingDetails.originalType} {pricingDetails.original}{' '}
                        {pricingDetails.dashed}
                        {pricingDetails.percentOff && (
                            <span data-automation-id="price-percent-off">
                                {pricingDetails.percentOff}
                            </span>
                        )}
                    </p>
                )}
            </div>
        );
    };

    let badge = '';
    const inventory = get(savedListItem, 'inventory.quality', '');
    const message = get(savedListItem, 'inventory.message', '');
    if (inventory === 'low') {
        badge = 'Few Left';
    }
    // Move to messagesTexts
    if (message === 'Out Of Stock Online') {
        badge = 'Out of Stock';
    }
    const {
        product: { image: { url } = {}, name } = { image: {} },
        attributes: SKUList,
        quantity,
        pricing: { marketingLabel } = {},
        dateAdded,
        mostWanted,
    } = savedListItem;
    const SKUListView = [];
    const SKUSection = {
        fontFamily: 'OpenSans',
        fontSize: '14px',
        lineHeight: '1.33',
        color: '#4a4a4a',
    };
    if (SKUList) {
        for (let idx = 0; idx < SKUList.length; idx += 1) {
            SKUListView.push(<span style={SKUSection}> {SKUList[idx].value} |</span>);
        }
    }
    quantity && SKUListView.push(<span style={SKUSection}> Qty: {quantity}</span>);
    const webID = get(savedListItem, 'webId', '');
    const divImage = {
        width: '82px',
        height: '83.8px',
        marginRight: '5px',
        display: 'inline-block',
    };
    const image = {
        display: 'block',
        width: '82px',
        height: '71.8px',
        marginLeft: '8.3px',
    };
    const productSection = {
        display: 'inline-block',
        width: '70%',
        marginLeft: '8px',
        marginRight: '20px',
    };
    const productName = {
        fontFamily: 'OpenSans',
        fontSize: '16px',
        fontWeight: 'bold',
        color: '#1c2024',
    };
    const rightSection = {
        display: 'inline-block',
        width: '30%',
        marginRight: '3px',
        textAlign: 'right',
    };
    const centerItems = {
        display: 'flex',
        alignItems: 'center',
        border: '1px solid #d8d8d8',
        marginBottom: '16px',
        minHeight: '150px',
    };
    const doorBuster = {
        fontFamily: 'OpenSans',
        fontSize: '8px',
        fontWeight: 'bold',
        color: '#cb0c0b',
    };

    const high = {
        fontFamily: 'OpenSans',
        fontSize: '16px',
        color: '#111111',
        lineHeight: '1.25',
        fontWeight: 'bold',
        marginRight: '10px',
        height: '120px',
    };

    const webId = {
        fontFamily: 'OpenSans',
        fontSize: '14px',
        marginRight: '10px',
        color: '#53606b',
        lineHeight: '1.6',
        height: '30px',
        verticalAlign: 'bottom',
    };

    const dateAddedCss = {
        fontFamily: 'OpenSans',
        fontSize: '14px',
        color: '#53606b',
    };

    const borderGrey = {
        width: '60px',
        height: '16px',
        fontFamily: 'OpenSans',
        backgroundColor: '#ffffff',
        color: '#000',
        fontSize: '10px',
        border: '1px solid #bbbbbb',
        textAlign: 'center',
    };
    return (
        <div>
            <div style={centerItems}>
                <div style={divImage}>
                    <img src={url} style={image} alt="product" />
                </div>
                <div style={productSection}>
                    <p style={productName}>
                        <p style={doorBuster} data-automation-id="at-price-marketing-label">
                            {marketingLabel}
                        </p>
                        {priceDetailsView()}
                        <div>{name}</div>
                        <div>{SKUListView}</div>
                        {dateAdded && (
                            <div style={dateAddedCss}>
                                Added {time(dateAdded).format('MMMM DD, YYYY')}
                            </div>
                        )}
                        {badge && <div style={borderGrey}>{badge}</div>}
                    </p>
                </div>
                <div style={rightSection}>
                    {mostWanted && <div style={high}>High Priority</div>}
                    {!mostWanted && <div style={high} />}
                    {webID && <div style={webId}>webID: {webID}</div>}
                </div>
            </div>
        </div>
    );
}
Print.propTypes = {
    savedListItem: PropTypes.object,
};
Print.defaultProps = {
    savedListItem: {},
};
export default Print;
